const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI;

export function buildGraphqlCurl({ url, query, variables, token, maskToken = true }) {
  const displayToken = maskToken && token ? `${token.slice(0, 12)}…` : token;
  const body = JSON.stringify({ query, variables }, null, 2);
  const escapedBody = body.replace(/'/g, "'\\''");

  return [
    `curl -X POST '${url || `${API_BASE_URL}${GRAPHQL_URI}`}' \\`,
    `  -H 'Content-Type: application/json' \\`,
    `  -H 'Authorization: Bearer ${displayToken}' \\`,
    `  -d '${escapedBody}'`,
  ].join("\n");
}

export function buildPresignedCurl({ token, payload, maskToken = true }) {
  const presignedPath = process.env.REACT_APP_API_PRESIGNED_URL_ENDPOINT || "/presigned";
  const displayToken = maskToken && token ? `${token.slice(0, 12)}…` : token;
  const body = JSON.stringify(payload, null, 2);
  const escapedBody = body.replace(/'/g, "'\\''");

  return [
    `curl -X POST '${API_BASE_URL}${presignedPath}' \\`,
    `  -H 'Content-Type: application/json' \\`,
    `  -H 'Authorization: Bearer ${displayToken}' \\`,
    `  -d '${escapedBody}'`,
  ].join("\n");
}
